import React from 'react';

import { Product } from 'types/state';
import { AdminContentLayout } from 'design/adminContentLayout';
import { ProductsTable } from 'containers/ProductsTable';
import { AdminPageHeadLayout } from 'design/adminPageHeadLayout';
import { AdminPageTitleLayout } from 'design/adminPageTitleLayout';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { useProductsService } from 'hooks/useProductsService';
import { ProductManager } from 'containers/ProductManager';
import { TextComponent } from 'design/text/textComponents';
import { AdminNotificationPanel } from 'containers/AdminNotificationPanel';

export const ProductsPageContent = () => {
  const intl = useIntlDictionary();

  const [
    productIdToShowDetailsFor,
    setProductIdToShowDetailsFor,
  ] = React.useState<null | number>(null);

  const { productsState, getProducts } = useProductsService();

  React.useLayoutEffect(() => {
    getProducts();
  }, [getProducts]);

  const [tableItems, setTableItems] = React.useState<null | Product[]>(null);

  React.useEffect(() => {
    const tableItems =
      productsState && productsState.resolvedWith && productsState.resolvedWith;

    if (tableItems) {
      setTableItems(tableItems);
    }
  }, [productsState]);

  const onProductDetailsClose = React.useCallback(() => {
    setProductIdToShowDetailsFor(null);
  }, []);

  const handleTableItemClick = React.useCallback((id: number) => {
    setProductIdToShowDetailsFor(id);
  }, []);

  const handleProductEditorSubmitDidSucceed = React.useCallback(() => {
    getProducts();
  }, [getProducts]);

  const handleTariffEditorSubmitDidSucceed = React.useCallback(() => {
    getProducts();
  }, [getProducts]);

  const handleTariffDeleteDidSucceed = React.useCallback(() => {
    getProducts();
  }, [getProducts]);

  return (
    <AdminContentLayout
      headNode={
        <AdminPageHeadLayout>
          <AdminNotificationPanel />
          <AdminPageTitleLayout
            textNode={
              <TextComponent size="mp">
                {intl.adminNavigation.productsLinkText}
              </TextComponent>
            }
            actionNode={null}
          />
        </AdminPageHeadLayout>
      }
      bodyNode={
        <>
          {tableItems !== null && (
            <ProductsTable
              items={tableItems}
              activeItemId={productIdToShowDetailsFor || undefined}
              onItemClick={handleTableItemClick}
            />
          )}
          {productIdToShowDetailsFor !== null && (
            <ProductManager
              productId={productIdToShowDetailsFor}
              onProductEditorSubmitDidSucceed={
                handleProductEditorSubmitDidSucceed
              }
              onTariffEditorSubmitDidSucceed={
                handleTariffEditorSubmitDidSucceed
              }
              onTariffDeleteDidSucceed={handleTariffDeleteDidSucceed}
              onClose={onProductDetailsClose}
            />
          )}
        </>
      }
    />
  );
};
